import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useCallback, useRef } from 'react';
import { useEventListener } from '@magento/peregrine/lib/hooks/useEventListener';
export var useDrawer = function useDrawer() {
  var drawerRef = useRef(null);

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      activateDrawer = _useState2[0],
      setActiveDrawer = _useState2[1];

  var closeDrawer = function closeDrawer() {
    setActiveDrawer(null);
  };

  var handleDrawerActions = function handleDrawerActions(type, data) {
    return setActiveDrawer({
      type: type,
      data: data
    });
  }; // collapse on mousedown outside of the element and trigger.


  var maybeCollapse = useCallback(function (_ref) {
    var target = _ref.target;
    var isOutsideElement = !drawerRef.current || !drawerRef.current.contains(target);

    if (isOutsideElement) {
      setActiveDrawer(null);
    }
  }, []);
  useEventListener(globalThis.document, 'mousedown', maybeCollapse);
  return {
    activateDrawer: activateDrawer,
    handleDrawerActions: handleDrawerActions,
    closeDrawer: closeDrawer,
    drawerRef: drawerRef
  };
};